export const appHead = {"meta":[{"charset":"utf-8"},{"name":"theme-color","media":"(prefers-color-scheme: light)","content":"#ffffff"},{"name":"theme-color","content":"#ffffff"},{"name":"apple-mobile-web-app-status-bar-style","content":"#ffffff"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-itunes-app","content":"app-id=1441761075"},{"name":"viewport","content":"width=device-width, maximum-scale=1, minimum-scale=1, initial-scale=1, user-scalable=no, shrink-to-fit=no"},{"http-equiv":"x-dns-prefetch-control","content":"on"},{"name":"description","content":"L'application de révision pour réussir sa scolarité : quiz expliqués, fiches de révision imprimables, préparation à l'Oral, annales corrigées, culture générale & coaching"}],"link":[{"rel":"dns-prefetch","href":"https://cdn.adam.nomadeducation.fr"},{"rel":"icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","href":"/images/app-icons/icon-512x512.png","sizes":"512x512"}],"style":[],"script":[{"type":"text/x-mathjax-config","innerHTML":"\n            window.MathJax = window.MathJax || {};\n            MathJax.Hub.Config({\n              showMathMenu: false,\n              messageStyle: 'none',\n              CommonHTML: {\n                scale: 100,\n                linebreaks: {\n                  automatic: true,\n                },\n                mtextFontInherit: false,\n              },\n              tex2jax: {\n                preview: 'none',\n                processEscapes: false,\n                processEnvironments: false,\n                skipTags: [\"script\",\"noscript\",\"style\",\"textarea\",\"pre\",\"code\"],\n                inlineMath: [\n                  ['$', '$'],\n                  ['\\\\(', '\\\\)'],\n                ],\n              },\n              \"HTML-CSS\": {\n                styles: { \".MathJax_Display\": { margin: 0 } },\n                linebreaks: { automatic: true },\n                mtextFontInherit: false,\n              },\n            });\n          "},{"src":"https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.6/MathJax.js?config=TeX-AMS_CHTML","crossorigin":"anonymous"}],"noscript":[],"title":"Nomad Education","htmlAttrs":{"lang":"fr"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true